<div class="modal modal--max fade"
  id="addons-modal"
  tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false"
  aria-labelledby="addons-modal"
  aria-modal="true">
  <div class="modal-dialog">
    @if (vap && vapQuestion) {
      <div class="modal-content">
        <header class="modal-addons__header">
          <div class="container-fluid">
            <div class="modal-addons__title">
              <div class="icon icon--md vap-icon">
                <img [src]="vap?.vaps_icon ? 'assets/icn/vaps/sm-' + vap?.vaps_icon : ''" alt="">
              </div>
              <div class="modal-addons__title-txt">
                <h4>{{vap?.name}}</h4>
                <p>{{vap?.vaps_description}}</p>
              </div>
            </div>
          </div>
          @if (!isEdit) {
            <button (click)="removeBenefits()" class="modal-addons__close">
              <svg class="icon">
                <use xlink:href="#close-circle-small"></use>
              </svg>
            </button>
          }
        </header>
        <!-- /.addons__header -->
        <div class="modal-addons__content">
          <div class="modal-addons__content-inner">
            <div class="container-fluid">
              <div class="modal-addons__items">
                <!--<app-question-controller
                [question]="question"
                [addAnother]="addAnother"
                [collations]="collations"
                [collation_vaps]="collation_vaps"
                [vap]="vap"
                [product_id]="product_id"
                [addAddons]="addAddons"
                (amountChanged)="onAmountChange($event)">
              </app-question-controller>-->
              <app-vaps-mini-flow-parent
                (itemsChanged)="onItemsChanged($event)"
                [vap]="vap"
                [productId]="product_id"
                [isEdit]="isEdit"
                [vapQuestion]="vapQuestion">
              </app-vaps-mini-flow-parent>
            </div>
            <!-- /.modal-addons__items -->
            <!--<div class="modal-addons__add" *ngIf="question?.add_another === 1">-->
            <!--<div class="modal-addons__add">
            <div class="button-control" (click)="addAnotherItem()">
              <svg class="icon icon&#45;&#45;sm">
                <use xlink:href="#plus"></use>
              </svg>
              <strong>Add Another</strong>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="modal-addons__btn">
      <div class="container-fluid">
        <div class="modal-addons__btn-inner">
          @if (!isEdit) {
            <button class="button button--primary button--lg" [disabled]="total == 0" (click)="addAllAddons()">
              {{'Add ' + (globalQuestionService?.accounting ? globalQuestionService?.accounting?.formatMoney(total) : 'R '+total) + ' /' + (globalQuestionService?.currency ? globalQuestionService?.currency?.display_freq : 'mo')}}
            </button>
          }
          @if (isEdit) {
            <button (click)="addAllAddons()" class="button button--primary button--lg">
              Update
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}
</div>
</div>
